<template>
  <b-row>
    <b-col>
      <b-row class="justify-content-center my-4">
        <b-col class="mb-4 mb-sm-0" cols="12" sm="6" md="5" lg="4">
          <label>Indiquer la date</label>
          <ValidationProvider
            ref="vee-meeting-meeting_date"
            v-slot="{ errors, classes }"
            :name="'réunion date'"
            rules="required"
            :events="['change']"
            mode="passive"
          >
            <v-date-picker
              v-model="meeting.meeting_date"
              locale="fr"
              mode="dateTime"
              is-required
              is24hr
              :timezone="timezone"
              :masks="masks"
              @change="
                updateMeeting(
                  'meeting_date',
                  $event ? $moment($event).format('YYYY-MM-DDTHH:mm:ssZ') : null
                )
              "
            >
              <template v-slot="{ inputValue, inputEvents }">
                <input
                  class="bg-white border px-2 py-1 rounded"
                  :value="inputValue"
                  v-on="inputEvents"
                />
              </template>
            </v-date-picker>
            <span :class="classes">{{ errors[0] }}</span>
          </ValidationProvider>
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>
<script>
import VCalendar from "v-calendar/lib/components/calendar.umd";
import VDatePicker from "v-calendar/lib/components/date-picker.umd";
export default {
  components: {
    vCalendar: VCalendar,
    vDatePicker: VDatePicker,
  },
  props: {
    meeting: {
      type: Object,
      require: true,
    },
  },
  data() {
    return {
      masks: {
        inputDateTime: ["DD MMMM YYYY HH:mm", "YYYY-MM-DD HH:mm", "YYYY/MM/DD HH:mm"],
        inputDateTime24hr: ["DD MMMM YYYY HH:mm", "YYYY-MM-DD HH:mm", "YYYY/MM/DD HH:mm"],
      },
    };
  },
  computed: {
    timezone() {
      return localStorage.getItem("timezone");
    },
  },
  created() {
    if (this.timezone) {
      this.$moment.tz.setDefault(this.timezone);
    }
  },
  methods: {
    formatDate(date) {
      // HACK
      // Because online database is saving date in FR timezone (+01:00) with utc time without changing the hour,
      // this code will check that and will format the timezone back to utc and then to local date
      if (
        this.$moment.parseZone(date).utcOffset() > 0 ||
        this.$moment.parseZone(date).utcOffset() < 0
      ) {
        let utcFormatted = this.$moment
          .parseZone(date)
          .utcOffset(0, true)
          .format("YYYY-MM-DDTHH:mm:ssZ");
        return this.$moment(utcFormatted).format("YYYY-MM-DDTHH:mm:ssZ");
      } else {
        return this.$moment(date).format("YYYY-MM-DDTHH:mm:ssZ");
      }
    },
    updateMeeting(key, value) {
      this.$emit("updateMeeting", key, value);
    },
  },
};
</script>
